module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/768f8a4db20d6ee1eb918671cd7d3ad4.png";